import React from "react";
import { Link } from "react-router-dom";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import PdfZipItem from "../../../components/PdfZipItem";

const Mou = ({ data }) => {
  const { getText } = useLanguageTranslation();
  useTableResponsive(data);

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
          <div className="title-sec">
            <h2>{getText("Memorandum of Understanding", "समझौता ज्ञापन")}</h2>
          </div>
          <div className="table-responsive">
            <table className="table table-striped custom-table">
              <thead className="thead-dark">
                <tr>
                  <th style={{ width: "56px" }}>
                    {getText("S.No.", "क्रमांक")}
                  </th>
                  <th>{getText("Financial Year", "वित्तीय वर्ष")}</th>
                  <th>{getText("Download", "डाउनलोड")}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                    <td data-key={getText("Financial Year", "वित्तीय वर्ष")}>
                      {item.title}
                    </td>
                    <td data-key={getText("Download", "डाउनलोड")}>
                      {item.field_download ? (
                        <PdfZipItem
                          filePath={item?.field_download}
                          filesize={item?.filesize}
                        />
                      ) : (
                        <>
                          <Link
                            to={`/reports/${item.nid}`}
                            className="division-pdf-icon"
                          >
                            <span className="date">
                              {getText("View More", "और देखें")}
                            </span>
                          </Link>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mou;
